export const environment = {
  production: false,
  apiUrl: 'https://dxykejehtrj70.cloudfront.net/api/v1',  // URL para el entorno de desarrollo
  // apiUrl: 'http://localhost:5000/api/v1',
  oauth: {
    clientId: '30vor6idtuufs3oi66hciogee', // Cliente ID para desarrollo
    cognitoDomain: 'https://cl00018-user-pool-botboris-cx-dev-test-v2-477672527642.auth.us-east-1.amazoncognito.com',
    identityProvider: 'Google',
    scopes: ['email', 'openid', 'profile']
  },
  allowedRoles: ['admin', 'cx', 'analytic', 'dev', 'infraestructura', 'comercial', 'cdt'],
  chat: {
    // Minutos de inactividad para regeneracion sessionId
    inactivityTimeoutMinutes: 10
  }
};